import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Link,
  title: 'Link',
  category: ComponentCategory.General,
};
